import React, { useCallback, useEffect, useState } from 'react';
import { hostName, isLocal } from '../../../constants/apiEnv';
import TrainingDetail from '../Detail/TrainingDetail';
import Loading from '../../../components/loading';

function TrainingContent(props) {
  const { match: { params }, history } = props;
  const [trainingData, setTrainingData] = useState({});
  const [trainingDraft, setTrainingDraft] = useState({});
  const [loading, setLoading] = useState(false);

  const getTrainingInfo = useCallback(async () => {
    try {
      const url = hostName.slice(6);
      const publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${params?.backendId || 'us'}${url}/public`;
      setLoading(true);
      await fetch(`${publicUrl}/lms/training/${params.airportCode.toUpperCase()}/${params.trainingId}/`)
        .then(response => response.json())
        .then(async (data) => {
          setTrainingData(data);
        });

      // manage public training draft information
      await fetch(`${publicUrl}/lms/public_training_draft/${params.airportCode.toUpperCase()}/${params.trainingId}/`)
        .then(response => response.json())
        .then((draftData) => {
          setTrainingDraft(draftData);
        });
    } catch (error) {
      // nothing
    } finally {
      setLoading(false);
    }
  }, [params]);

  const saveTrainingDraft = async (trainingId, payload) => {
    const url = hostName.slice(6);
    const publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${params?.backendId || 'us'}${url}/public`;
    setLoading(true);
    try {
      const res = await fetch(`${publicUrl}/lms/public_training_draft/${params.airportCode.toUpperCase()}/${trainingId}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!res.ok) {
        throw new Error(`Error: ${res.statusText}`);
      }

      const data = await res.json();
      setTrainingDraft(data);
    } catch (err) {
      // nothing
    } finally {
      setLoading(false);
    }
  };

  const completePublicTraining = useCallback(async (id, payload) => {
    const url = hostName.slice(6);
    const publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${params?.backendId || 'us'}${url}/public`;
    setLoading(true);
    try {
      const res = await fetch(`${publicUrl}/lms/public_complete_training/${params.airportCode.toUpperCase()}/${params.trainingId}/${id}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      if (!res.ok) {
        throw new Error(`Error: ${res.statusText}`);
      }
      history.push(`/lms/view/training/${params?.backendId}/${params.airportCode.toUpperCase()}/${params?.trainingId}`);
    } catch (err) {
      // nothing
    } finally {
      setLoading(false);
    }
  }, [history, params]);


  useEffect(() => {
    if (Object.keys(trainingData).length === 0) {
      getTrainingInfo();
    }
  });


  return (
    <>
      <Loading loadingStatus={loading} />
      {Object.keys(trainingData)?.length > 0 && (
        <TrainingDetail
          {...props}
          actionFetchTrainingDetails={getTrainingInfo}
          trainingInfo={trainingData}
          draftData={trainingDraft}
          completePublicTraining={completePublicTraining}
          saveTrainingDraft={saveTrainingDraft}
          isPublic
        />
      )}
    </>
  );
}

export default TrainingContent;
